import SurveyCard from './SurveyCard';

const SurveysCards = ({ surveys, stats, period }) => {
  return surveys.map((survey) => {
    return <SurveyCard key={survey.id} survey={survey} stats={stats} period={period} />;
  });
};

export default SurveysCards;
